module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_edit-c81fb0e458e49cb503dbb8dd9f06fdc3.svg";